export default from './Icon';



// WEBPACK FOOTER //
// ./src/elements/icon/index.js